// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2eKK3","title":"Images45_title__3D4ga","images":"Images45_images__6LAPN"};